
import VueWait from 'vue-wait'
let wait

if (!wait) {
  wait = new VueWait({
    useVuex: true
  })
}

export default wait



// WEBPACK FOOTER //
// ./src/lib/wait.js